<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <!--table-->
        <div>
          <button type="button" id="BtnPopup" (click)="showPublisher()" style="display:none">Search</button>
          <table #dataTable class="display" style="width:100%"></table>
        </div>

        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--Loader gif-->
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>

              <div class="modal-body" style="overflow-x:auto !important;">
                <div class="card">
                  <div class="card-body">
                    <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
                      <li class="nav-item"><a data-toggle="tab" href="#divPrimary" class="nav-link active">Primary</a></li>
                      <li class="nav-item"><a data-toggle="tab" href="#divsecondary" class="nav-link">Secondary</a></li>
                      <li class="nav-item"><a data-toggle="tab" href="#divNotes" class="nav-link">Notes</a></li>
                    </ul>
                    <br />

                    <!--Primary Tab-->

                    <div class="tab-content">
                      <div class="tab-pane active" id="divPrimary">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4">
                              <label>Publisher Code<em>*</em></label>
                              <input id="Txt_PubCode" type="text" class="form-control" maxlength="40" autocomplete="off" />
                            </div>
                            <div class="col-sm-4">
                              <label>Publisher Name<em>*</em></label>
                              <input id="Txt_Acronym" type="text" class="form-control" maxlength="40" autocomplete="off" />
                            </div>
                            <div class="col-sm-4">
                              <label>Registrant  Code<em>*</em></label>
                              <input id="Txt_RegCode" type="text" class="form-control" maxlength="40" autocomplete="off" />
                            </div>&nbsp;
                           
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-8">
                              <label>Publisher Title<em>*</em></label>`
                              <input id="Txt_PubTitle" type="text" class="form-control " maxlength="40" autocomplete="off" />
                            </div>
                            <div class="col-sm-3">
                              <label>NT Allocation Page</label>`
                              <input id="Txt_AllocationPage" type="text" class="form-control " maxlength="40" autocomplete="off" />
                            </div>
                            <div class="col-sm-1">
                              <div class="form-group">
                                <input type="checkbox" id="chkAutoBooking">
                                &nbsp;<label>Auto Booking</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4">
                              <label> Email Id</label>
                              <input id="Txt_Name" type="text" class="form-control skipSpecialChar" (change)="MultipleEmail($event)" maxlength="80" autocomplete="off" />
                            </div>
                            <div class="col-sm-4">
                              <label>Physics Email ID<em>*</em></label>
                              <input id="Txt_PhyEmail" type="text" class="form-control" maxlength="40" autocomplete="off" (change)="MultipleEmail($event)" />
                            </div>
                            <div class="col-sm-4">
                              <label>Journal Type<em>*</em></label>
                              <select id="ddlJournalType" class="form-control">
                                <option *ngFor="let item of journalType" value={{item.SNo}}>
                                  {{item.TypeName}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4">
                              <label>Contact No.<em>*</em></label>
                              <input type="text" id="Txt_mobile" class="form-control IsNumeric" (change)=numbervalidate($event) maxlength="10" autocomplete="off">
                            </div>
                            <div class="col-sm-4">
                              <label>Zip Post Code<em>*</em></label>
                              <input id="Txt_ZipCode" type="text" class="form-control" maxlength="6" autocomplete="off" />
                            </div>
                            <div class="col-sm-4">
                              <label>Region Name<em>*</em></label>
                              <input id="Txt_RegionName" type="text" class="form-control " autocomplete="off" />
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Address<em>*</em></label>
                              <textarea class="form-control" id="Txt_address" autocomplete="off"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-4">
                              <label>Country<em>*</em></label>
                              <select class="form-control" id="ddlCountry" (change)="GetState(0)">
                                <option value="0" disabled selected>Select Country</option>
                                <option *ngFor="let item of CountryList" value={{item.ID}}>{{item.CountryName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-4">
                              <label>State<em>*</em></label>
                              <select class="form-control" id="ddlState" (change)="GetCity(0,0)">
                                <option value="0" disabled selected>Select State</option>
                                <option *ngFor="let itemS of stageList" value={{itemS.ID}} [selected]="itemS.ID==StateIDPop">{{itemS.StateName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-4">
                              <label>City<em>*</em></label>
                              <select class="form-control" id="ddlCity">
                                <option value="0" disabled selected>Select City</option>
                                <option *ngFor="let itemCT of CityList" value={{itemCT.ID}} [selected]="itemCT.ID==CityidPop">{{itemCT.CityName}}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <label>Logo</label>
                          <div class="input-group" style="text-align:center;">
                            <img src="../../../assets/Images/userLogo.jpg" alt="Profile" style="height:110px;width:110px;margin-top:10px;border-radius:10px;" id="imgProfile" (error)="onerrorImageLoad()" /> <br /><br />
                            <input type="file" name="file" id="imageUploadForm" style="width: 100%;margin-left:10px" class="btn" (change)="showPreview($event)" />
                          </div>
                        </div>
                      </div>

                      <div class="tab-pane" id="divsecondary">
                        <div class="col">
                          <div class="row">
                            <div class="col-sm-4">
                              <label>Facsimile</label>
                              <input type="text" class="form-control" id="Txt_facsimile" maxlength="40" autocomplete="off" />
                            </div>
                            <div class="col-sm-4" id="JournalCEID">
                              <label for="txtCEID">CE</label>
                              <select class="form-control" id="txtCEID">
                                <option *ngFor="let item of CEIDList" value={{item.ID}}>
                                  {{item.Name}}
                                </option>
                              </select>
                            </div>
                            <div class="col-sm-4" id="JournalPageLayoutID">
                              <label for="txtPageLayoutID">PageLayout</label>
                              <select class="form-control" id="txtPageLayoutID">
                                <option *ngFor="let item of PageLayoutList" value={{item.SNo}}>
                                  {{item.Name}}
                                </option>
                              </select>
                            </div>
                          </div><br />


                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-4" id="JournalStyleID">
                                <label for="StyleId">Style</label>
                                <select class="form-control" id="StyleId">
                                  <option *ngFor="let item of styleList" value={{item.SNo}}>
                                    {{item.StyleName}}
                                  </option>
                                </select>
                              </div>
                              <div class="col-sm-4" id="JournalProjectFromID">
                                <label for="txtProjectFromID">Project From</label>
                                <select class="form-control" id="txtProjectFromID">
                                  <option *ngFor="let item of ProjectFromList" value={{item.ID}}>
                                    {{item.Name}}
                                  </option>
                                </select>
                              </div>
                              <div class="col-sm-4" id="JournalBillingID">
                                <label for="txtBillingID">Billing</label>
                                <select class="form-control" id="txtBillingID">
                                  <option *ngFor="let item of BillingList" value={{item.SNo}}>
                                    {{item.TypeName}}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>


                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-6" id="JournalPlatform">
                                <label for="lstPlatform ">Platform</label>
                                <select class="form-control" id="lstPlatform">
                                  <option *ngFor="let item of platformList" value={{item.SNo}}>
                                    {{item.Name}}
                                  </option>
                                </select>
                              </div>
                              <div class="col-sm-6">
                                <label>Secret Key</label>
                                <input type="text" class="form-control" id="Txt_secretkey" autocomplete="off" />
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-6">
                                <label>Web Address</label>
                                <input type="text" id="Txt_webaddress" class="form-control IsNumeric" maxlength="40" autocomplete="off">
                              </div>
                              <div class="col-sm-6">
                                <label>Web Link</label>
                                <input type="text" class="form-control" id="Txt_weblink" autocomplete="off" />
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-12" id="JournalStagesList">
                                <div class="form-group">
                                  <label for="ddlStagesList ">Stages</label>
                                  <select id="ddlStagesList" class="form-control" multiple>
                                    <option *ngFor="let item of StageList" value={{item.ID}}>
                                      {{item.StageName}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-sm-12">
                                <label>License Subscription</label>
                                <textarea class="form-control" id="Txt_licensesubscription" autocomplete="off"></textarea>
                              </div>&nbsp;
                              <div class="col-sm-12">
                                <label>License Open Access</label>
                                <textarea class="form-control" id="Txt_licenseopenaccess" autocomplete="off"></textarea>
                              </div>
                            </div>&nbsp;
                            <div class="row">
                              <div class="col-sm-3">
                                <div class="form-group">
                                  <input type="checkbox" id="chkForceAllowIssueClosure">
                                  &nbsp;<label>Force Allow Issue Closure</label>
                                </div>
                              </div>
                             
                            </div>
                          </div>
                        </div>
                      </div>


                      <!--Notes Info tab-->
                      <div class="tab-pane" id="divNotes">
                        <div class="row">
                          <div class="col-6" id="notesJournal" style="padding-top: 2em;">

                            <div class="col-lg" id="PublisherGeneralNotes">
                              <div class="form-group">
                                <label for="txtGeneralNotes">General Notes</label>
                                <textarea type="text" class="form-control" id="txtGeneralNotes" rows="10" autocomplete="off"> </textarea>
                              </div>

                            </div>
                            <div class="row">
                              <div class="col-6">
                                <div class="GeneralUploadFile">
                                  <input class="form-control" #fileInput type="file" (change)="GeneralUploadSelected($event)" id="gendoc_uploadfile" />
                                  <em>['doc', 'docx', 'pdf', 'zip','xlsx','xls']</em>
                                </div>
                              </div>
                              <div *ngIf="GeneralNotesFile!='' && GeneralNotesFile!=null" class="col-6">
                                <!--<i class='bx bx-download' style='font-size: 20px !important;cursor: pointer !important;color: #556ee6;padding: 2px;' (click)="DownloadPublisherNotes('main')"></i>-->
                                <button class="btn" style="color:#556ee6" (click)="DownloadPublisherNotes('main')">
                                  {{GeneralNotesFile}}
                                </button>
                              </div>
                            </div>

                          </div>
                          <div class="col-6">
                            <div class="col-12">
                              <label style="padding-top:20px;">Stage Notes</label>
                              <span id="spAddPublisherNotes" class="btn btn-outline-info waves-effect waves-light Addbtn" (click)="showPublisherNotes()"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                            </div>
                            <button type="button" id="btnDeletePublisherNotes" (click)="Deleteconfirmation()" style="display:none">Delete JournalNotes</button>
                            <button type="button" id="btnDeletePublisherNote" (click)="deletePublisherNotes()" style="display:none">Delete JournalNotes</button>
                            <button type="button" id="btnDwnldjNotes" (click)="DownloadPublisherNotes()" style="display:none">Download JournalNotes</button>
                            <div class="form-group col-12 tblRightsList fixTableHead">
                              <table id="tblAddPublisherNotes" class="table" Style="width:100%">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Stage Type</th>
                                    <th>Description</th>
                                    <th style='text-align: center'>Actions</th>
                                  </tr>
                                </thead>
                                <tbody></tbody>
                              </table>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="submit" (click)="UpdatePublisher()" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="myModalnotes" [style.display]="showNotesModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideNotes()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <div class="col-12">
            <div class="row">
              <div class="col-sm-12">
                <label for="ddlArticlestag">Stage List</label>
                <select id="ddlArticlestage" class="form-control">
                  <option *ngFor="let item of articleStageList" value={{item.StageName}}>
                    {{item.StageName}}
                  </option>
                </select>
              </div>&nbsp;
              <div class="col-sm-12" id="JNotesDescription">
                <label for="JNotesDescription ">Description</label>
                <textarea type="text" class="form-control" rows="10" id="PublisherNotesDescription"> </textarea>
              </div>&nbsp;
            </div>
            <div class="row">
              <div class="col-sm-4">
                <div class="UploadFile">
                  <input #fileInput type="file" (change)="onuploadSelected($event)" id="doc_uploadfile" />
                  <em>['doc', 'docx', 'pdf', 'zip','xlsx']</em>
                </div>
              </div>
              <div class="col-sm-8">
                <div id="btndownloadPublisherNotes">
                  <button class="btn" id="btndownloadJnotes" style="color:#556ee6" (click)="DownloadPublisherNotes()"><i class="fa fa-download"></i> {{FileName}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideNotes()">Close</button>
        <button type="submit" (click)="addUpdateNotes()" class="btn btn-outline-success waves-effect waves-light">{{NotesModalButton}}</button>
      </div>
    </div>
  </div>
</div>
